export const USERS_STATUSES = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
} as const;

export type UserStatus = (typeof USERS_STATUSES)[keyof typeof USERS_STATUSES];
